import { Box, CircularProgress } from "@mui/joy";
import type { StatsDateRange } from "../../../api/stats/Stats.typed";
import DarkCard from "../../common/DarkCard";
import DarkTypography from "../../common/DarkTypography";
import InstructorEncadrantFilter from "../../common/InstructorEncadrantFilter";
import { useInstructorStatsData } from "../hooks/useInstructorStatsData";
import InstructorStatsBarChart from "./InstructorStatsBarChart";

type InstructorStatsSectionProps = {
  range: StatsDateRange;
  periodLabel: string;
};

export default function InstructorStatsSection({
  range,
  periodLabel,
}: InstructorStatsSectionProps) {
  const { rows, options, instructorId, setInstructorId, loading } = useInstructorStatsData(range);

  return (
    <DarkCard sx={{ minWidth: 0, gridColumn: "1 / -1" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 1,
          mb: 1.5,
        }}
      >
        <DarkTypography level="title-md" colorVariant="title">
          Par moniteur
        </DarkTypography>
        <InstructorEncadrantFilter
          value={instructorId}
          onInstructorChange={setInstructorId}
          options={options}
        />
      </Box>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress color="neutral" size="sm" />
        </Box>
      )}

      {!loading && rows.length === 0 && (
        <DarkTypography colorVariant="muted" sx={{ textAlign: "center", py: 2 }}>
          Aucune donnée pour {periodLabel}.
        </DarkTypography>
      )}

      {!loading && rows.length > 0 && <InstructorStatsBarChart rows={rows} />}
    </DarkCard>
  );
}
